import { render, staticRenderFns } from "./_dialog.vue?vue&type=template&id=2b5e8e34&"
import script from "./_dialog.vue?vue&type=script&lang=js&"
export * from "./_dialog.vue?vue&type=script&lang=js&"
import style0 from "./_dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports